/**
 * URL suffix builder for chart context IDs.
 *
 * This module provides the utility to extract a URL suffix from pathname
 * and search params. The full chart ID is built by useRegisterChartContext.
 *
 * @see useRegisterChartContext.ts for the single-layer ID builder
 * @see chartContextRegistry.ts for valid chart names and context groups
 */

/**
 * Extract the URL suffix from pathname and search params.
 * This creates a unique identifier based on the full URL context.
 *
 * For URL: https://atlas-localhost.stackline.com/company/WjnegYbwZ1?rid=1&pid=prior-year&sw=202601&ew=202604&sdid=20260104&edid=20260131&wr=ytd&tab=trafficV2&subtab=totalClicks
 * Returns: company/WjnegYbwZ1?rid=1&pid=prior-year&sw=202601&ew=202604&sdid=20260104&edid=20260131&wr=ytd&tab=trafficV2&subtab=totalClicks
 *
 * @param pathname - URL pathname (e.g., '/company/WjnegYbwZ1')
 * @param search - URL search string (e.g., '?rid=1&pid=prior-year&...')
 * @returns URL suffix string
 */
export const buildUrlSuffix = (pathname: string, search: string): string => {
  // Remove leading slash from pathname
  const cleanPathname = pathname.startsWith('/') ? pathname.slice(1) : pathname;
  // Remove leading '?' from search if present
  const cleanSearch = search.startsWith('?') ? search.slice(1) : search;

  if (cleanSearch) {
    return `${cleanPathname}?${cleanSearch}`;
  }
  return cleanPathname;
};
